import { useState, useCallback, useRef, useMemo } from 'react';
import useEditor from '@wix/da-editor-tiptap/pkg/hooks/useEditor';
import { externalRenderers } from '../config';
import { useCurrentUser } from '../../utils/hooks/useCurrentUser';
/**
 * Main hook for all consumers to use, creates a set of props
 * ready to use with the base editor components and ref to the
 * editorApi
 */ const useEditorNg = (options)=>{
    const { editorApi, editorProps } = useEditor(options);
    const currentUser = useCurrentUser();
    const [showMSProps, setshowMSProps] = useState(undefined);
    const [showMMProps, setshowMMProps] = useState(undefined);
    const callbackMSRef = useRef(null);
    const callbackMMRef = useRef(null);
    const onSelectMedia = useCallback((cb, props)=>{
        setshowMSProps(props !== null && props !== void 0 ? props : {});
        callbackMSRef.current = cb;
    }, []);
    const onManageMedia = useCallback((cb, props)=>{
        setshowMMProps(props !== null && props !== void 0 ? props : {});
        callbackMMRef.current = cb;
    }, []);
    const editorSharedProps = useMemo(()=>({
            onSelectMedia,
            onManageMedia,
            externalRenderers,
            currentUser
        }), [
        currentUser,
        onManageMedia,
        onSelectMedia
    ]);
    const onSelect = useCallback((selected)=>{
        if (callbackMSRef.current) {
            setshowMSProps(undefined);
            callbackMSRef.current(selected);
        }
    }, []);
    const onManageDone = useCallback((selected)=>{
        if (callbackMMRef.current) {
            setshowMMProps(undefined);
            callbackMMRef.current(selected);
        }
    }, []);
    const editorCommonProps = {
        onSelect,
        mediaSelectorProps: showMSProps,
        setMediaSelectorProps: setshowMSProps,
        mediaManagerProps: showMMProps,
        onManageDone,
        setMediaManagerProps: setshowMMProps
    };
    return {
        editorApi,
        editorProps,
        editorSharedProps,
        editorCommonProps
    };
};
export default useEditorNg;

//# sourceMappingURL=useEditorNg.js.map